import { Offer, RollingOfferProductSequence } from 'common/contracts';
import { MIN_USD_PRICE } from 'constants/constants';
import { OfferType } from 'constants/enums';
import Decimal from 'decimal.js';

import {
  buildBaseInitialValues,
  buildOfferUiIdInitialValue,
  buildScheduleInitialValue
} from 'views/Offers/Offer.utils';

export const convertPriceToCents = (price: number): number => {
    if (price === 0) return 0;
    return new Decimal(price).mul(100).toNumber();
};

export const convertPriceFromCents = (priceInCents: number): number => {
    if (priceInCents === 0) return 0;
    return new Decimal(priceInCents).div(100).toNumber();
};

export const validateNumericField = (
    value: number | undefined | null,
    { min, max, fieldName }: { min?: number; max?: number; fieldName: string }
): string | null => {
    if (value === undefined || value === null) return null;
    if (min !== undefined && value < min) return `${fieldName} must be at least ${min}`;
    if (max !== undefined && value > max) return `${fieldName} must be at most ${max}`;
    return null;
};

// --- Form initial values ---

interface IBuildRollingOfferFormInitialValuesParams {
  data: Partial<Offer>;
  edit: boolean;
  dup: boolean;
  defaultOfferDesignId: string;
  getOfferResult?: Partial<Offer>;
}

export const buildRollingOfferFormInitialValues = ({
  data,
  edit,
  dup,
  defaultOfferDesignId,
  getOfferResult
}: IBuildRollingOfferFormInitialValuesParams) => ({
  ...buildBaseInitialValues(data, edit, dup),
  type: OfferType.ROLLING_OFFER,
  priority: data.priority || 1,
  offerUiId: buildOfferUiIdInitialValue(
    data, edit, dup, defaultOfferDesignId, getOfferResult
  ),
  schedule: buildScheduleInitialValue(data),
  price: MIN_USD_PRICE,
  productsSequence: data.productsSequence
    ? (data.productsSequence as RollingOfferProductSequence[]).map(
        (product: RollingOfferProductSequence) => ({
          ...product,
          progressBarPoints: product.progressBarPoints || [
            { points: 0, barId: '' }
          ],
          priceInUsdCents: convertPriceFromCents(
            product?.priceInUsdCents || 0
          )
        })
      )
    : []
});

